const initialState = {
  selected: {},
};

export default initialState;
